import { useIntl } from '@/intl'
import { UnavailableContentDialog } from '@sunwebgroup/ui-components'

import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  height: 100vh;
  > * {
    height: 100%;
    align-items: center;
  }
`

export function CheckoutGroupsNotificationError() {
  const intl = useIntl()

  return (
    <Wrapper>
      <UnavailableContentDialog
        title={intl.formatMessage({ id: 'groups_checkout_steps_error_title' })}
        message={intl.formatMessage({ id: 'groups_checkout_steps_error_description' })}
      >
      </UnavailableContentDialog>
    </Wrapper>
  )
}
